export var Actions;
(function (Actions) {
    Actions["KEYPHRASE_CHANGED"] = "questions/KEYPHRASE_CHANGED";
})(Actions || (Actions = {}));
